import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { FC, useState } from 'react';

interface ServiceWorkerUpdateDialogProps {
  registration: ServiceWorkerRegistration;
}

const ServiceWorkerUpdateDialog: FC<ServiceWorkerUpdateDialogProps> = ({ registration }) => {
  const [show, setShow] = useState(!!registration.waiting);

  const onClick = () => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
    setShow(false);
    window.location.reload();
  };

  return (
    <Dialog open={show}>
      <DialogTitle style={{ textAlign: 'center' }}>アップデート通知</DialogTitle>
      <DialogContent>
        <DialogContentText>新しいバージョンがリリースされました🎉</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={onClick}>アップデート</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceWorkerUpdateDialog;
